"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var ListingLabel;
(function (ListingLabel) {
  ListingLabel["SALES"] = "sales";
  ListingLabel["RENTAL"] = "rental";
  ListingLabel["SHARE"] = "share";
})(ListingLabel || (ListingLabel = {}));
var _default = exports.default = ListingLabel;